module.exports = __webpack_public_path__ + "assets/img/2-whos-this-for-min.0d41df51.jpg";